import { StylistProfile } from '../types/auth';

interface WelcomeDisplayNameUser {
  role?: 'client' | 'stylist' | 'admin';
  userType?: 'client' | 'stylist' | 'admin';
  name?: string;
  stylistProfile?: StylistProfile;
}

/**
 * One consistent "Hello, {name}" rule shared by the client and stylist
 * dashboards:
 * - client: their own name
 * - stylist with a non-empty salon/business name: the salon name
 * - stylist without one: their own name
 * Returns '' (never undefined/null/whitespace) so callers can safely skip
 * rendering the greeting until a name is available.
 */
export const getWelcomeDisplayName = (user?: WelcomeDisplayNameUser | null): string => {
  if (!user) return '';

  const isStylist = (user.role ?? user.userType) === 'stylist';

  if (isStylist) {
    const salons = user.stylistProfile?.salons;
    const mainSalon = salons?.find((salon) => salon.isMain) ?? salons?.[0];
    const salonName = mainSalon?.name?.trim();
    if (salonName) return salonName;

    const businessName = user.stylistProfile?.businessInfo?.businessName?.trim();
    if (businessName) return businessName;
  }

  return user.name?.trim() ?? '';
};
